"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DHLExpress = void 0;
/**
 * Class to request custom SFRA DHLExpress endpoint
 */
class DHLExpress {
  /**
   * Create an instance of the API with the given config.
   * @param {ClientConfig} config - The config used to instantiate SDK apis.
   */
  constructor(config, fetch) {
    this._config = config;
    this._fetch = fetch;
  }
  getArrivalTime(args) {
    return this._fetch('DHLExpress-GetRates', 'post', args, 'GetArrivalTime');
  }
}
exports.DHLExpress = DHLExpress;